function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#000",
  d: "M19.4 16.296a9.268 9.268 0 01-2.813 1.972c-1.07.488-2.154.732-3.253.732-1.245 0-2.4-.248-3.461-.744a7.846 7.846 0 01-2.715-2.073 7.581 7.581 0 01-1.56-3.042H3.4v-1.397h1.956a9.413 9.413 0 01-.044-.79c0-.224.007-.39.022-.495H3.4V9.062h2.132a7.639 7.639 0 011.55-3.132 7.938 7.938 0 012.78-2.153C10.96 3.26 12.155 3 13.444 3c1.099 0 2.176.225 3.23.676a8.087 8.087 0 012.704 1.848l-1.714 2.208a6.34 6.34 0 00-1.945-1.498c-.74-.368-1.484-.552-2.231-.552-1.114 0-2.11.311-2.99.935a4.923 4.923 0 00-1.845 2.445h5.604v1.397H8.345a5.19 5.19 0 00.044 1.285h5.868v1.397H8.785a5.014 5.014 0 001.879 2.197 5.066 5.066 0 002.824.823 5.41 5.41 0 002.198-.485 6.476 6.476 0 001.978-1.363l1.736 1.983z",
  fillRule: "evenodd"
});

var SvgEur = function SvgEur(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/eur.8408693c.svg";
export { SvgEur as ReactComponent };